// db.js

import Dexie from "dexie";

// Create database
export const db = new Dexie("ChatUserDB");


// Create or Define tables and indexe
// Version 1: Add chats store for persisting chat list
db.version(1).stores({
  messages:
    "id, chatGroupId, messageText, messageTypeId, dateSent, fromUserId, translatedMessage, fromFirstName, isAdjacentMsg",
  chats: "chatGroupId, lastMessageTime, nrOfUsersInGroup, muted, unreadMessagesNr"
});



// ===========================
// Chat Helper Functions
// ===========================

/**
 * Save or update multiple chats in IndexedDB
 * @param {Array} chatsArray - Array of chat objects
 * @returns {Promise}
 */
export const saveChatsToIndexedDB = async (chatsArray) => {
  try {
    if (!Array.isArray(chatsArray) || chatsArray.length === 0) return;
    await db.chats.bulkPut(chatsArray);
  } catch (error) {
    console.error("❌ Error saving chats to IndexedDB:", error);
  }
};

/**
 * Get all chats from IndexedDB, sorted by dateSent descending
 * @returns {Promise<Array>}
 */
export const getChatsFromIndexedDB = async () => {
  try {
    // Get all chats without filtering
    const chats = await db.chats.toArray();

    // Sort by dateSent  (most recent first) - same as API sorting
    const sortedChats = chats.sort((a, b) => {
      let dateA = new Date(a.dateSent || 0),
        dateB = new Date(b.dateSent || 0);
      return dateB - dateA;
    });
    return sortedChats;
  } catch (error) {
    console.error("❌ Error retrieving chats from IndexedDB:", error);
    return [];
  }
};

/**
 * Update a single chat in IndexedDB
 * @param {number} chatGroupId - Chat group ID
 * @param {Object} updates - Fields to update
 * @returns {Promise}
 */
export const updateChatInIndexedDB = async (chatGroupId, updates) => {
  try {
    await db.chats.update(chatGroupId, updates);
  } catch (error) {
    console.error(`❌ Error updating chat ${chatGroupId}:`, error);
  }
};

/**
 * Delete a chat and all its messages from IndexedDB (cascade delete)
 * @param {number} chatGroupId - Chat group ID to delete
 * @returns {Promise}
 */
export const deleteChatandMessagesFromIndexedDB = async (chatGroupId) => {
  try {
    await db.chats.where("chatGroupId").equals(chatGroupId).delete();
    // Delete all messages for this chat
    await db.messages.where("chatGroupId").equals(chatGroupId).delete();
  } catch (error) {
    console.error(`❌ Error deleting chat ${chatGroupId}:`, error);
  }
};

/**
 * Get a single chat by ID
 * @param {number} chatGroupId - Chat group ID
 * @returns {Promise<Object|null>}
 */
export const getChatByIdFromIndexedDB = async (chatGroupId) => {
  try {
    const chat = await db.chats.get(chatGroupId);
    return chat || null;
  } catch (error) {
    console.error(`❌ Error getting chat ${chatGroupId}:`, error);
    return null;
  }
};

/**
 * Clear all chats from IndexedDB (useful for logout)
 * @returns {Promise}
 */
export const clearAllChatsFromIndexedDB = async () => {
  try {
    await db.chats.clear();
  } catch (error) {
    console.error("❌ Error clearing chats:", error);
  }
};

export const ChatClientDB = new Dexie("ChatClientDB");

ChatClientDB.version(1).stores({
  client_dashboard: "groupDetails.chatGroupId, userId, messageDetails.dateSent",
  client_messages: "id, chatGroupId, dateSent"
});

export const clearIndexDB = async () => {
  await ChatClientDB.client_dashboard.clear();
  await ChatClientDB.client_messages.clear();
  db.chats.clear();
  db.messages.clear();
}





